module.exports = __webpack_public_path__ + "static/bluecross-blueshield-global-logo-087fadc95e341bf777f58b8cbc06c6cd.png";